module.exports = __webpack_public_path__ + "static/media/rank-03-rookie.f914ba61.svg";